import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottoQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { SortOrder, SortBarModule } from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc7 from '@ngx-translate/core';

function LottosListComponent_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "fgbcl-sort-bar", 5);
    ɵngcc0.ɵɵlistener("defaultSortAction", function LottosListComponent_ng_container_1_ng_container_1_ng_container_1_Template_fgbcl_sort_bar_defaultSortAction_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.resetOrder(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lottos_r5 = ɵngcc0.ɵɵnextContext(2).ngIf;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("sortBarOptions", ctx_r7.sortBarOptions)("itemList", lottos_r5)("displayDefaultSort", true);
} }
function LottosListComponent_ng_container_1_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelement(2, "fgbcl-lottos-list-item", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("col-md-6", ctx_r8.isList)("col-lg-4", ctx_r8.isList);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("lottoItem", item_r12);
} }
function LottosListComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LottosListComponent_ng_container_1_ng_container_1_ng_container_1_Template, 2, 3, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, LottosListComponent_ng_container_1_ng_container_1_div_2_Template, 3, 5, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lottos_r5 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fgbWebsiteContentFeatureFlag", "fgbcl.feature.flag.lotto.sortbar");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", lottos_r5);
} }
function LottosListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LottosListComponent_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lottos_r5 = ctx.ngIf;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", lottos_r5.length)("ngIfElse", _r1);
} }
function LottosListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtext(2, "confirmation_number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 2, "lotto.placeholder.title"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 4, "lotto.placeholder.description"));
} }
function LottosListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "fgbcl-loading");
    ɵngcc0.ɵɵelementEnd();
} }
class LottosListComponent {
    constructor(lottoQuery) {
        this.lottoQuery = lottoQuery;
        this.sortOrderType = SortOrder;
    }
    ngOnInit() {
        this.subscribeAndSortLottoItems();
        this.defineSortBarOptions();
    }
    subscribeAndSortLottoItems() {
        this.lottos$ = this.lottoQuery.selectLottos();
    }
    defineSortBarOptions() {
        this.sortBarOptions = [
            {
                propertyToSort: 'PurchasePrice',
                shouldToggle: false,
                order: this.sortOrderType.Descending,
                labelDESC: 'lotto.high.low',
            },
            {
                propertyToSort: 'PurchasePrice',
                shouldToggle: false,
                order: this.sortOrderType.Ascending,
                labelASC: 'lotto.low.high',
            },
            {
                propertyToSort: 'AvailableCount',
                shouldToggle: true,
                order: this.sortOrderType.Descending,
                labelASC: 'lotto.limited.availability',
                labelDESC: 'lotto.high.availability',
            },
            {
                propertyToSort: 'Title',
                shouldToggle: true,
                order: this.sortOrderType.Descending,
                labelASC: 'lotto.a.z',
                labelDESC: 'lotto.z.a',
            },
        ];
    }
    resetOrder() {
        this.subscribeAndSortLottoItems();
    }
}
LottosListComponent.ɵfac = function LottosListComponent_Factory(t) { return new (t || LottosListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LottoQuery)); };
LottosListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LottosListComponent, selectors: [["fgbcl-lottos-list"]], inputs: { isList: "isList" }, decls: 7, vars: 6, consts: [[4, "ngIf", "ngIfElse"], ["noLottos", ""], ["loadingRef", ""], [4, "fgbWebsiteContentFeatureFlag"], [3, "col-md-6", "col-lg-4", 4, "ngFor", "ngForOf"], [1, "row", "w-100", 3, "sortBarOptions", "itemList", "displayDefaultSort", "defaultSortAction"], [1, "loyalty-item-container"], [3, "lottoItem"], [1, "no-items", "w-100", "text-center"], ["aria-hidden", "true", 1, "icon", "material-icons-two-tone", "no-results-placeholder-icon", "text-center"], [1, "no-results-placeholder-title", "font-weight-bold", "text-primary", "text-uppercase"], [1, "no-results-placeholder-text", "text-info", "mb-5"], [1, "w-100"]], template: function LottosListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, LottosListComponent_ng_container_1_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, LottosListComponent_ng_template_3_Template, 9, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, LottosListComponent_ng_template_5_Template, 2, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵclassProp("row", ctx.isList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 4, ctx.lottos$))("ngIfElse", _r3);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.WebsiteContentFeatureFlagDirective, ɵngcc2.NgForOf, ɵngcc4.SortBarComponent, ɵngcc5.LottosListItemComponent, ɵngcc6.LoadingComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc7.TranslatePipe], styles: [""] });
LottosListComponent.ctorParameters = () => [
    { type: LottoQuery }
];
LottosListComponent.propDecorators = {
    isList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottosListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-lottos-list',
                template: "<div [class.row]=\"isList\">\r\n  <ng-container *ngIf=\"lottos$ | async as lottos; else loadingRef\">\r\n    <ng-container *ngIf=\"lottos.length; else noLottos\">\r\n      <ng-container *fgbWebsiteContentFeatureFlag=\"'fgbcl.feature.flag.lotto.sortbar'\">\r\n        <fgbcl-sort-bar\r\n          class=\"row w-100\"\r\n          [sortBarOptions]=\"sortBarOptions\"\r\n          [itemList]=\"lottos\"\r\n          [displayDefaultSort]=\"true\"\r\n          (defaultSortAction)=\"resetOrder()\"\r\n        ></fgbcl-sort-bar>\r\n      </ng-container>\r\n      <div *ngFor=\"let item of lottos\" [class.col-md-6]=\"isList\" [class.col-lg-4]=\"isList\">\r\n        <div class=\"loyalty-item-container\">\r\n          <fgbcl-lottos-list-item [lottoItem]=\"item\"></fgbcl-lottos-list-item>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n\r\n<!-- No results -->\r\n<ng-template #noLottos>\r\n  <div class=\"no-items w-100 text-center\">\r\n    <div class=\"icon material-icons-two-tone no-results-placeholder-icon text-center\" aria-hidden=\"true\">confirmation_number</div>\r\n    <div class=\"no-results-placeholder-title font-weight-bold text-primary text-uppercase\">\r\n      {{ 'lotto.placeholder.title' | translate }}\r\n    </div>\r\n    <div class=\"no-results-placeholder-text text-info mb-5\">{{ 'lotto.placeholder.description' | translate }}</div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Loading -->\r\n<ng-template #loadingRef>\r\n  <div class=\"w-100\">\r\n    <fgbcl-loading></fgbcl-loading>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.LottoQuery }]; }, { isList: [{
            type: Input
        }] }); })();

class LottosListModule {
}
LottosListModule.ɵfac = function LottosListModule_Factory(t) { return new (t || LottosListModule)(); };
LottosListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LottosListModule });
LottosListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ErrorsModule,
            SortBarModule,
            LoadingModule,
            LottosListItemModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LottosListModule, { declarations: function () { return [LottosListComponent]; }, imports: function () { return [CommonModule,
        ErrorsModule,
        SortBarModule,
        LoadingModule,
        LottosListItemModule,
        DirectivesModule, ɵngcc7.TranslateModule]; }, exports: function () { return [LottosListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottosListModule, [{
        type: NgModule,
        args: [{
                declarations: [LottosListComponent],
                imports: [
                    CommonModule,
                    ErrorsModule,
                    SortBarModule,
                    LoadingModule,
                    LottosListItemModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [LottosListComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LottosListComponent, LottosListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-lottos-lottos-list.js.map